import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './direct-deposit.component.html';
import angular from 'angular';
import { InfoModal } from '../info-modal/info-modal.component';
import { VoidCheckModal } from './void-check-modal.component';

export const DirectDepositComponent = {
    templateUrl,
    controller: DirectDepositController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        bankInfo: "<",
        savedInfo: "<",
        accountTypes: "<",
        depositTypes: "<",
        close: "&",
        dismiss: "&"
    }
};

function DirectDepositController(onboardingActionPolicy, utilityService, $uibModal, $state, $scope, $q, onboardingDocumentService, localeService, $timeout) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('7', vm.application) === 'View';
    vm.state = {
        view: 'DirectDeposit'
    };
    vm.ddForm = {
        status: '',
        originStatus: '',
        bankAccountID: '',
        accountTypeID: '',
        accountTypeKendo: '',
        depositTypeID: '',
        depositTypeKendo: '',
        depositValue: '',
        bankName: '',
        routingNumber: '',
        confirmRoutingNumber: '',
        institutionNumber: '',
        confirmInstitutionNumber: '',
        accountNumber: '',
        confirmAccountNumber: ''
    }
    //originstatus: 1 - existing, 2 - saved existing, 3- new
    vm.asterisks = {};
    vm.editForm;
    //vm.ddForm = {};
    vm.onShowI9 = onShowI9;
    vm.onSubmit = onSubmit;
    vm.isSaveAllowed = isSaveAllowed;
    vm.onSave = onSave;
    vm.onShowConfirmation = onShowConfirmation;
    vm.onChangeAccount = onChangeAccount;
    vm.onClose = onClose;
    vm.maskingLength = maskingLength;
    vm.prefilled = false;
    vm.requireInstitutionNumber = false;
    vm.employeeId;
    vm.existingBankAccID;
    vm.reqReview = false;
    vm.canApproveForm = (rt) => canApproveForm(vm.application, rt);
    vm.editable = true;
    vm.editClicked = false;
    vm.showSavedNotification = false;
    vm.requestReview = requestReview;
    vm.retrieveLocale = retrieveLocale;
    vm.onAddDD = onAddDD;
    vm.onContinue = onContinue;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.ddAdded = false;
    vm.allowSubmit = false;
    vm.voidCheck;
    vm.maskLength = 4;
    vm.maskData = maskData;
    vm.generateAsterisks = generateAsterisks;
    vm.getAsterisks = getAsterisks;
    vm.getLastFour = getLastFour;
    vm.onChangeAccountType = onChangeAccountType;
    vm.onChangeDeposit = onChangeDeposit;
    vm.enforceDepositFormat = enforceDepositFormat;
    vm.isSSNMismatched = isSSNMismatched;
    vm.ssnIsValidated = ssnIsValidated;
    vm.onClearAll = onClearAll;
    vm.onEditClick = onEditClick;
    vm.openModal = openModal;
    vm.ddList;
    vm.savedList;
    vm.status;
    vm.originStatus;

    vm.toggleSSN = toggleSSN;

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }

        if (this.profile.HomeAddress.CountryID === 2) {
            vm.requireInstitutionNumber = true;
        }
        vm.retrieveLocale()
            .then(function (locale) {
                //vm.employeeBankInfo.LocaleID = locale.localeID;
                //vm.employeeBankInfo.ShowMaritalStatus = vm.employeeBankInfo.CountryID === 1;
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;

            });
        if (vm.application) {
            // Owner never edits the employee's DD; keep it non-editable so the read-only display (ng-if="!vm.editable")
            // renders for the owner even when DD is ReviewRequired (otherwise both the edit and read-only branches hide -> blank).
            vm.editable = !vm.ownerView && !(vm.application && (vm.application.DirectDeposit === 'Submitted' || vm.application.DirectDeposit === 'Approved' || vm.application.ApplicationStatus === 'Approved'));
        }

        vm.ddForm.depositTypeKendo = vm.depositTypes.find(deposit => deposit.DepositAmountTypeID === 1);
        vm.ddForm.depositTypeID = 1;
        //fill user data
        if (this.savedInfo != null && vm.savedInfo.length > 0) {
            console.log(this.savedInfo);
            this.savedInfo.map(dd => {
                let dt = angular.copy(vm.ddForm);
                vm.originStatus = 2; //saved
                vm.status = 3;
                dt.bankAccountID = dd.BankAccountID;
                dt.accountTypeID = dd.BankAccountTypeID;
                dt.depositTypeID = dd.DepositAmountTypeID;
                dt.accountTypeKendo = vm.accountTypes.find(account => account.BankAccountTypeID === dd.BankAccountTypeID);
                dt.depositTypeKendo = vm.depositTypes.find(deposit => deposit.DepositAmountTypeID === dd.DepositAmountTypeID);
                dt.depositValue = dd.DepositAmount;
                dt.routingNumber = dd.RoutingNumber;
                dt.confirmRoutingNumber = dd.RoutingNumber;
                dt.bankName = dd.BankName;
                dt.institutionNumber = dd.InstitutionNumber;
                dt.confirmInstitutionNumber = dd.InstitutionNumber;
                dt.accountNumber = dd.AccountNumber;
                dt.confirmAccountNumber = dd.AccountNumber;
                vm.ddList = dt;
                vm.ddAdded = true;
                vm.allowSubmit = true;
                vm.prefilled = true;
                console.log(dt);
            });
            vm.showSavedNotification = true
        } else if (this.bankInfo != null && this.bankInfo.length > 0) {
            console.log(this.bankInfo);
            this.bankInfo.map(dd => {
                let dt = angular.copy(vm.ddForm);
                vm.originStatus = 1; //existing
                vm.status = 3;
                dt.bankAccountID = dd.BankAccountID;
                vm.existingBankAccID = dd.BankAccountID;
                dt.accountTypeID = dd.BankAccountTypeID;
                dt.depositTypeID = dd.DepositAmountTypeID;
                dt.accountTypeKendo = vm.accountTypes.find(account => account.BankAccountTypeID === dd.BankAccountTypeID);
                dt.depositTypeKendo = vm.depositTypes.find(deposit => deposit.DepositAmountTypeID === dd.DepositAmountTypeID);
                dt.depositValue = dd.DepositAmount;
                dt.routingNumber = dd.RoutingNumber;
                dt.confirmRoutingNumber = dd.RoutingNumber;
                dt.bankName = dd.BankName;
                dt.institutionNumber = dd.InstitutionNumber;
                dt.confirmInstitutionNumber = dd.InstitutionNumber;
                dt.accountNumber = dd.AccountNumber;
                dt.confirmAccountNumber = dd.AccountNumber;
                vm.ddList = dt;
                vm.ddAdded = true;
                vm.allowSubmit = true;
                vm.prefilled = true;
                console.log(dt);
            })
            //vm.ddForm.routingNumber = this.bankInfo.RoutingNumber;
            //vm.ddForm.confirmRoutingNumber = this.bankInfo.RoutingNumber;
            //vm.ddForm.bankName = this.bankInfo.BankName;
            //vm.ddForm.institutionNumber = this.bankInfo.InstitutionNumber;
            //vm.ddForm.confirmInstitutionNumber = this.bankInfo.InstitutionNumber;
            //vm.ddForm.accountNumber = this.bankInfo.AccountNumber;
            //vm.ddForm.confirmAccountNumber = this.bankInfo.AccountNumber;
            //vm.ddAdded = true;
        } else {
            vm.originStatus = 3;
        }
        utilityService.hideLoading();
    }

    function openModal() {
        return $uibModal.open({
            ...VoidCheckModal,
            resolve: {
                isCA: () => {
                    return (vm.employeeBankInfo && vm.employeeBankInfo.CountryID === 2);
                },
                state: () => {
                    return "onboarding-document.federalW4";
                }
            },
            windowClass: 'responsive-w4-modal',
            backdrop: 'static'
        }).result
        //$uibModal.open({
        //    template: `
        //      <div class="modal fade show" id="previewModal" style="display:block; background-color: rgba(10,10,10,.4);">
        //        <div class="modal-dialog">
        //        <div class="modal-content">

        //            <div class="modal-header">
        //                <h4 class="modal-title">Void Check</h4>
        //                <button type="button" class="close">&times;</button>
        //            </div>

        //            <div class="modal-body text-center">
        //                <img src="{{src}}" style="max-width:100%; max-height:70vh;">
        //            </div>

        //            <div class="modal-footer">
        //                <button class="btn btn-secondary" ng-click="vm.closePreview()">Close</button>
        //            </div>

        //        </div>
        //        </div>
        //    </div>`,
        //    controller: function ($scope) {
        //        $scope.src = src;
        //    },
        //    size: 'lg'
        //});
    };

    $scope.$watch('vm.editForm.$dirty', function (value) {
        // This is how we tell if there are unsaved form changes so we don't navigate away
        if (value) {
            vm.prefilled = false;
        }
    }, false);


    function maskingLength(str) {
        return str.length < 4 ? str.length : str.length - 4;
    }

    function onAddDD() {
        vm.ddAdded = true;
        vm.allowSubmit = true;
        let ddFormNew = angular.copy(vm.ddForm);
        vm.originStatus = 3; //newly added
        vm.status = 3; //add new
        vm.ddList = ddFormNew;
        /*return clearInputs();*/
    }

    function onClearAll() {
        if (vm.originStatus === 2) {
            vm.status = 2 //clear saved - submit empty
            vm.allowSubmit = true;
        } else if (vm.originStatus === 1) {
            vm.status = 1; //clear existing submitted - give only submit option to clear - clear submitted bankacc
            vm.allowSubmit = true;
        } else if (vm.originStatus === 3) {
            vm.status = 0;//clear newly added - do nothing
        }
        vm.savedList = angular.copy(vm.ddList);
        vm.ddList = null;
        //vm.ddList = vm.ddList.filter(function (item) {
        //    var deferred = $q.defer();
        //    if (item.status === 1) {
        //        onboardingDocumentService.removeBankAccount(item.bankAccountID).then(function (response) {
        //            deferred.resolve("Bank account removed successfully.");
        //        });
        //    } else {
        //        deferred.resolve("Condition not met, no action taken.");
        //    }
        //    vm.prefilled = false;
        //    vm.editable = true;
        //    return false;
        //});

        if (vm.ddList == null) {
            vm.ddAdded = false;
        }
    }

    function onEditClick() {
        vm.editable = !vm.editable;
        vm.editClicked = !vm.editClicked;
        if (vm.savedList != null) {
            vm.ddList = angular.copy(vm.savedList);
        }
    }

    function toggleSSN(propName, value, $event) {
        console.log($event.type);
        console.log(value);
        if (value) {
            vm[propName] = true;
            $timeout(function () {
                vm[propName] = false;
            }, 5000);
        }

    }

    function clearInputs() {
        vm.ddForm.bankName = null;
        vm.ddForm.routingNumber = null;
        vm.ddForm.confirmRoutingNumber = null;
        vm.ddForm.institutionNumber = null;
        vm.ddForm.confirmInstitutionNumber = null
        vm.ddForm.accountNumber = null;
        vm.ddForm.confirmAccountNumber = null;
        return utilityService.hideLoading();
    }

    function onContinue() {
        utilityService.showLoading();
        clearInputs();
        return onShowConfirmation();
    }

    function onApprove() {
        let message = "Please note that once approved, the DD will be sent to your payroll to be processed and removed from Apex. If you are unsure, click \"Cancel\" to go back.";
        if (confirm(message)) {
            let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "7");
            return $q.all(approvePromise).then((res) => {
                if (res) {
                    vm.onShowConfirmation();
                }
            }).catch((err) => {
                return $q.reject(err);
            });
        }
    }

    function isSaveAllowed() {
        if (vm.ddList != null) {
            let obj1 = angular.copy(vm.ddList);

            const properties = ['bankAccountID', 'bankName', 'routingNumber', 'confirmRoutingNumber', 'institutionNumber', 'confirmInstitutionNumber', 'accountNumber', 'confirmAccountNumber', 'depositTypeKendo', 'accountTypeKendo', 'depositValue'];
            return !properties.every(prop => {
                const hasValue = obj1[prop] !== undefined && obj1[prop] !== '' && obj1[prop] !== null;

                if (hasValue) {
                    console.log(`Property '${prop}' failed with value: ${obj1[prop]}`);
                }

                return !hasValue;
            });
        }
        return false;
    }

    function onSave() {
        if (vm.ownerView) {
            return;
        }
        if (!(vm.editForm && vm.editForm.$dirty)) {
            return;
        }
        //utilityService.showLoading();
        let updatePromises = [];
        //let clear = false;
        //check for remove flag here
        if (vm.status === 2) {
            updatePromises.push(onboardingDocumentService.clearSavedBankAccount(vm.employee.EmployeeID));
            vm.showSavedNotification = true;
        } else if (vm.status === 1) {
            //no action
            console.log('no action 1');
        } else if (vm.status === 3) {
            updatePromises.push(onboardingDocumentService.saveBankAccount({
                BankAccountID: vm.ddList.bankAccountID,
                EmployeeNumber: vm.employee.EmployeeID,
                BankName: vm.ddList.bankName,
                RoutingNumber: vm.ddList.routingNumber,
                AccountNumber: vm.ddList.accountNumber,
                InstitutionNumber: vm.ddList.institutionNumber,
                BankAccountTypeID: vm.ddList.accountTypeID,
                DepositAmountTypeID: vm.ddList.depositTypeID,
                DepositAmount: parseFloat(vm.ddList.depositValue)
            }));
            vm.showSavedNotification = true
        } else {
            console.log('no action');
        }

        vm.savedList = null;

        const prom = $q.all(updatePromises).then((res) => {
            console.log(res);
            vm.editForm.$setPristine();
            utilityService.hideLoading();
        }).catch((err) => {
            utilityService.hideLoading();
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(prom, "Save failed")
        );
    }

    function onSubmit() {
        if (vm.ownerView) {
            return onApprove();
        }
        if (!vm.ddAdded && !vm.allowSubmit) {
            utilityService.showLoading();
            if (!vm.ownerView) {
                clearInputs();
            }
            return onShowConfirmation();
        }

        if (vm.ddAdded && vm.editForm && vm.editForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return false;
        }
        vm.savedList = null;
        let updatePromises = $q.resolve();
        if (vm.editForm && vm.editForm.$dirty || vm.allowSubmit) {
            if (vm.status === 2) {
                updatePromises = onboardingDocumentService.clearSavedBankAccount(vm.employee.EmployeeID);
            } else if (vm.status === 1) {
                updatePromises = onboardingDocumentService.removeBankAccount(vm.existingBankAccID);
            } else if (vm.status === 3) {
                updatePromises = onboardingDocumentService.submitBankAccount({
                    BankAccountID: vm.ddList.bankAccountID,
                    EmployeeNumber: vm.employee.EmployeeID,
                    BankName: vm.ddList.bankName,
                    RoutingNumber: vm.ddList.routingNumber,
                    AccountNumber: vm.ddList.accountNumber,
                    InstitutionNumber: vm.ddList.institutionNumber,
                    BankAccountTypeID: vm.ddList.accountTypeID,
                    DepositAmountTypeID: vm.ddList.depositTypeID,
                    DepositAmount: parseFloat(vm.ddList.depositValue)
                });
            } else {
                console.log('no action submit');
            }
            vm.showSavedNotification = false;
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            return onShowConfirmation();
        }

        const trans = $q.all(updatePromises).then((res) => {
            if (res) {
                vm.editForm.$setPristine();
                onShowConfirmation();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }


    function requestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '7');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function onChangeAccount(data, index) {
        if (vm.editForm) {
            vm.editForm['routingNumber_'].$setValidity("validRoutingNumber", isRoutingNumberValid(data))
            vm.editForm['confirmRoutingNumber_'].$setValidity("matching", routingNumberMatching(data))
            if (vm.requireInstitutionNumber) {
                vm.editForm['institutionNumber_'].$setValidity("validInstitutionNumber", isInstitutionNumberValid(data))
                vm.editForm['confirmInstitutionNumber_'].$setValidity("matching", institutionNumberMatching(data))
            }

            vm.editForm['confirmAccountNumber_'].$setValidity("matching", accountNumberMatching(data))
            if (vm.editForm.$invalid) {
                return;
            }
        }
    }

    function onChangeAccountType(index, data) {
        if (vm.editForm) {
            data.accountTypeID = (data.accountTypeKendo ? data.accountTypeKendo.BankAccountTypeID : null);
        }
    }

    function onChangeDeposit(index, data) {
        if (vm.editForm) {
            data.depositTypeID = (data.depositTypeKendo ? data.depositTypeKendo.DepositAmountTypeID : null);
        }
        if (data.depositTypeID !== 2 && data.depositTypeID !== 3) {
            data.depositValue = null;
        } else {
            enforceDepositFormat();
        }
    }

    function enforceDepositFormat() {
        if (vm.ddList.depositValue === null || vm.ddList.depositValue === undefined || vm.ddList.depositValue === '') return;
        var val = parseFloat(vm.ddList.depositValue);
        if (isNaN(val)) return;
        if (vm.ddList.depositTypeID === 2) {
            // Partial $ - truncate to 2 decimal places
            vm.ddList.depositValue = Math.floor(val * 100) / 100;
        } else if (vm.ddList.depositTypeID === 3) {
            // Partial % - integer only, max 99
            val = Math.floor(val);
            if (val > 99) val = 99;
            if (val < 0) val = 0;
            vm.ddList.depositValue = val;
        }
    }

    function isRoutingNumberValid(account): boolean {
        var valid = account.routingNumber
            && account.routingNumber.length === 9 && /^\d+$/.test(account.routingNumber);
        console.log(account);
        return valid;
    }

    function routingNumberMatching(account): boolean {
        if (account.routingNumber === null || account.routingNumber === undefined) {
            return false;
        }
        return account.routingNumber && account.routingNumber === account.confirmRoutingNumber;
    }

    function isInstitutionNumberValid(account): boolean {
        return account.institutionNumber && account.institutionNumber.length ===
            3 && /^\d+$/.test(account.institutionNumber);
    }

    function institutionNumberMatching(account): boolean {
        if (account.institutionNumber === null || account.institutionNumber === undefined) {
            return false;
        }
        return account.institutionNumber && account.institutionNumber === account.confirmInstitutionNumber;
    }

    function accountNumberMatching(account): boolean {
        if (account.accountNumber === null || account.accountNumber === undefined) {
            return false;
        }
        return account.accountNumber && account.accountNumber === account.confirmAccountNumber;
    }

    function ssnIsValidated(index) {
        if (vm.ddForm != null) {
            if (((vm.editForm.accountNumber + '_' + index || "") !== (vm.editForm.confirmAccountNumber + '_' + index || "")) && vm.editForm.confirmAccountNumber + '_' + index === "") {
                return true;
            }
        }

        return false;
    }

    function isSSNMismatched(index) {
        if (vm.editForm != null) {
            if ((vm.editForm.accountNumber + '_' + index || "") !== (vm.editForm.confirmAccountNumber + '_' + index || "")) {

                return true;
            }
        }

        return false;
    }

    function onShowI9() {
        if (vm.ownerView) {
            return $state.go("application-status.ownermodal.i9");
        }
        if (!vm.prefilled) {
            return $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "onboarding-document.i9";
                    }
                },
                size: 'sm',
                backdrop: 'static'
            }).result
        }
        return $state.go("onboarding-document.i9");
    }

    function onShowConfirmation() {
        vm.close({ $value: 'ok' });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.editForm.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log('dismissed');
            });
        }
    }


    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function maskData(data) {
        // Mask all but the last 4 digits
        var maskedAccount = data.length > 0 ? data.substring(0, data.length - 4).replace(/./g, '*') + data.substring(data.length - 4) : undefined;
        return maskedAccount;
    }

    function generateAsterisks(field) {
        var inputLength = vm.editForm[field] && vm.editForm[field].$viewValue.length > 4 ? vm.editForm["bankName"].$viewValue.length - 4 : 0;
        vm.asterisks[field] = new Array(inputLength);
    }

    function getAsterisks(field) {
        return vm.asterisks[field];
    };

    function getLastFour(field) {
        var input = vm.ddForm[field] || '';
        return input.substring(Math.max(input.length - 4, 0));
    };
}

export interface ValidNewBankAccount {
    bankName: string;
    routingNumber: string;
    accountNumber: string;
    institutionNumber: string | null;
    depositAmountTypeID: number | null;
    depositAmount: number | null;
    voidCheck: File | null;
    adpDirectDeposit: File | null;
}

interface NewBankAccount {
    bankName?: string;
    routingNumber?: string;
    confirmRoutingNumber?: string;
    accountNumber?: string;
    confirmAccountNumber?: string;
    institutionNumber?: string;
    confirmInstitutionNumber?: string;
    depositAmountTypeID?: number;
    depositAmount?: number;
    voidCheck?: File;
    adpDirectDeposit?: File;
}




export const DDModal = {
    component: "apexDDModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}

